function applyInlineFont(el) {
  const computed = window.getComputedStyle(el);
  el.style.fontFamily = computed.fontFamily;
  el.style.fontSize = computed.fontSize;

  el.querySelectorAll('*').forEach((child) => {
    if (!child.style.fontFamily) {
      child.style.fontFamily = window.getComputedStyle(child).fontFamily;
    }
    if (!child.style.fontSize) {
      child.style.fontSize = window.getComputedStyle(child).fontSize;
    }
  });
}

const directive = {
  inserted(el) {
    requestAnimationFrame(() => applyInlineFont(el));
  },

  componentUpdated(el) {
    requestAnimationFrame(() => applyInlineFont(el));
  },
};

export default directive;
